module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-2-green-438b59b0064f5b66f60fd14af697713f.svg";